import FieldDimensionId from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import { BorderShapeId, TvUnitStorageShapeId } from '@core/constants/Shape';
import {
    IDimensionUnit,
    IFormFieldDimension,
    IFormFieldDimensionDefaultValueKey,
    IFormFieldMaterial,
    IFormFieldShape,
    IFormFieldShapeQuantities,
    IFormInputType,
} from '../../../interfaces/Form';
import allMaterials, {
    allGranites,
    allPlastics,
    allQuartz,
    allRecycledWoods,
    allRivers,
    getMaterialsWithExceptions,
} from './materialGroups';
import { allBorders, getBordersWithExceptions } from './shapesGroups';

export const fieldsTvUnitMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allMaterials,
                ...allGranites,
                ...allQuartz,
            ],
            [
                ...allPlastics,
                ...allRivers,
                ...allRecycledWoods,
                MaterialId.BlackLocust,
                MaterialId.Iroko,
                MaterialId.Douglas,
                MaterialId.DouglasEngineered,
                MaterialId.DouglasVeneer,
                MaterialId.Padouk,
                MaterialId.PadoukEngineered,
                MaterialId.PadoukVeneer,
                MaterialId.Ipe,
                MaterialId.IpeEngineered,
                MaterialId.IpeVeneer,
                MaterialId.Garapa,
                MaterialId.StainlessSteel,
                MaterialId.Zinc,
                MaterialId.SheetMetal,
            ],
        ),
        required: true,
    },
};

export const fieldsTvUnitBorders: IFormFieldShape = {
    value   : undefined,
    options : getBordersWithExceptions(allBorders,
        [
            BorderShapeId.LiveEdge,
        ]),
    required: true,
};

export const fieldsTvUnitDimensions: IFormFieldDimension = {
    [FieldDimensionId.Length]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 100,
        range         : { min: 500, max: 3000 },
        required      : true,
        defaultValue  : 1000,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardLength, 1000],
        ],
    },
    [FieldDimensionId.Width]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 100,
        range         : { min: 300, max: 800 },
        required      : true,
        defaultValue  : 500,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardWidth, 500],
        ],
    },
    [FieldDimensionId.Height]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 50,
        range         : { min: 300, max: 1000 },
        required      : true,
        defaultValue  : 400,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardHeight, 400],
        ],
    },
    [FieldDimensionId.Thickness]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 10,
        range         : { min: 10, max: 100 },
        required      : true,
        defaultValue  : 20,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardThickness, 20],
        ],
    },
};

export const fieldsTvUnitAddOns: IFormFieldShapeQuantities = {
    [TvUnitStorageShapeId.TvNiche]: {
        value : undefined,
        min   : 0,
        max   : 5,
    },
    [TvUnitStorageShapeId.TvDrawer]: {
        value : undefined,
        min   : 0,
        max   : 5,
    },
    [TvUnitStorageShapeId.TvDoor]: {
        value : undefined,
        min   : 0,
        max   : 5,
    },
};

